import actions from './actions';
import mutations from './mutations';
import { NoteState } from './types';

const state: NoteState = {
  visible: false,
  currentEditExample: false,
  totalCount: 0,
  noteList: [],
  hasNext: false,
  endCursor: '',
  sort: 'UPDATED_AT_DESC',
  // 配置项
  pageSize: 10,
  scrollTop: false
};


export default {
  namespaced: true,
  state,
  actions,
  mutations
};
